import { useEffect } from "react"
import { Routers } from "../../../../../../../constant/Routers"
import { backToLogin } from "../../../../../../../utils/backToLogin"
import {
  SchedulesBatchUpdateDataType,
  UseSchedulesBatchUpdateType,
} from "../../../../models/batchUpdate"
import { useVariables } from "../useVariables"

const { SCR920 } = Routers

export const useSchedulesBatchUpdate =
  (): UseSchedulesBatchUpdateType<SchedulesBatchUpdateDataType> => {
    const {
      beforeUpload,
      breadcrumbItems,
      bulkCheck,
      bulkDeleteData,
      bulkFileUpdate,
      bulkUpdate,
      columnErrors,
      columns,
      countRecord,
      dataTemps,
      errorList,
      fileNameList,
      isDisabledSubmit,
      isLoading,
      isLoadingLayout,
      isNotAccessScreen,
      isOpen,
      isOpenUploaded,
      isResetTable,
      isVisibleBtnCancel,
      isVisibleBtnUpdate,
      onCancel,
      onCancelUploaded,
      onChange,
      onOpen,
      onOpenDeleted,
      perItem,
      push,
    } = useVariables()

    const bulkDeleteDataConfirm = () => {
      bulkDeleteData()
      push(SCR920)
    }

    const onOpenDeletedOrGoToHome = () => {
      if (dataTemps.length) {
        onOpenDeleted()
      } else {
        push(SCR920)
      }
    }

    useEffect(() => {
      // ユーザの画面アクセス許可チェックを処理する。
      if (isNotAccessScreen) {
        // 「SCR973_エラー情報の表示画面」に遷移する。
        const { pathname, state } = backToLogin()
        push({ pathname, state })
      } else bulkCheck()
    }, [])

    return {
      beforeUpload,
      breadcrumbItems,
      bulkDeleteDataConfirm,
      bulkFileUpdate,
      bulkUpdate,
      columnErrors,
      columns,
      countRecord,
      dataTemps,
      errorList,
      fileNameList,
      isDisabledSubmit,
      isLoading,
      isLoadingLayout,
      isOpen,
      isOpenUploaded,
      isResetTable,
      isVisibleBtnCancel,
      isVisibleBtnUpdate,
      onCancel,
      onCancelUploaded,
      onChange,
      onOpen,
      onOpenDeletedOrGoToHome,
      perItem,
    }
  }
